import Axios from 'axios';
import { tryRefreshToken, handleUnauthorizedWithRefresh } from '../auth-refresh';

export const apiClient = Axios.create({
  baseURL: '/api',
  withCredentials: true,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('_authing_token');
  if (token) {
    config.headers.authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._refreshAttempted) {
      originalRequest._refreshAttempted = true;
      const refreshed = await tryRefreshToken();
      if (refreshed) {
        originalRequest.headers.authorization = `Bearer ${localStorage.getItem('_authing_token')}`;
        return apiClient(originalRequest);
      }
      await handleUnauthorizedWithRefresh();
    }
    return Promise.reject(error);
  },
);
